module.exports = __webpack_public_path__ + "img/20.c634c912.jpg";